// extracted by mini-css-extract-plugin
module.exports = {"viewMoreButton":"widgets_viewMoreButton__1DK6X"};